<script>
import Popin from "@/containers/popin-adaptive";
import Icon from "@/components/atoms/icon";
import Badge from "@/components/atoms/badge";
import Button from "@/components/atoms/button";
import Titre from "@/components/atoms/titre";
import StateOverlay from "@/components/molecules/state-overlay";

export default {
  name: "TransformerPoints",
  components: { Popin, Icon, Badge, Button, Titre, StateOverlay },
  props: {
    transformationCalled: {
      type: Boolean,
      required: false,
      default: false
    },
    simulationData: {
      type: Object,
      required: true
    },
    error: {
      type: Object,
      required: false,
      default: null
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },
  emits: ["validateTransformPoints"],
  data() {
    return {};
  },
  methods: {
    show() {
      this.$refs.popin.show();
    },
    hide() {
      const self = this;
      setTimeout(function () {
        self.$refs.popin.hide();
      }, 5000);
    }
  }
};
</script>

<template>
  <Popin
    ref="popin"
    v-bind="removeClassAndStyleFromAttrs($attrs)"
    aria-label="Transformation des points en €urocora réussie"
  >
    <StateOverlay
      ref="stateOverlay"
      :is-loading="isLoading"
      :error="error"
      :is-error="error !== null"
      size="s"
      overlay
      message="Traitement en cours..."
    >
      <div class="u-text-center u-pb-sm">
        <template v-if="transformationCalled">
          <Badge
            :variant="'success'"
            circle
            size="xlg"
          >
            <Icon
              name="check"
              variant="white"
            />
          </Badge>
          <p class="u-mt-sm u-font-15 u-font-16@sm">
            Transformation des points en €urocora réussie.
          </p>
        </template>

        <template v-else>
          <Titre
            tag="h1"
            variant="primary"
            size="md"
            class="u-mt-xs u-mb-md"
          >
            Transformer vos points
          </Titre>
          <p class="u-mb-lg u-font-15 u-mr-xlg u-mr-none@xs u-ml-xlg u-ml-none@xs">
            Vous avez demandé la transformation de {{ simulationData.mvtPoints }} points pour un montant de {{ simulationData.mvtEuros }} €urocora
          </p>
          <Button
            variant="primary"
            radius="full"
            size="md"
            @click="$emit('validateTransformPoints')"
          >
            Valider
          </Button>
        </template>
      </div>
    </StateOverlay>
  </Popin>
</template>

<style lang="scss" scoped>
</style>
